import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { UserVo } from "src/vo/userVo";
import { getCookie } from "src/utils/cookieUtil";
import jwtDecode from "jwt-decode";
import { isEmpty } from "lodash";
import { theme } from "src/styles/theme";

const token = getCookie("ac_token");
// const userInfo = Buffer.from(token, "base64").toString("utf8"); // 사파리 error
let userInfo: any = {};

if (token !== "undefined" && token !== null && typeof token !== "undefined") {
  userInfo = jwtDecode(token);
}

if (window.ReactNativeWebView) {
  // 안드로이드
  document.addEventListener("message", (e: { type: string; data?: string }) => {
    // if (!isEmpty(e.data)) {
    //   alert("안드로이드 =" + e.data);
    //   theme.mobile.notchHeight = Number(e.data);
    // }
  });
  // 아이폰
  window.addEventListener("message", (e: { type: string; data: string }) => {
    // alert("IOS = " + e.data);
    // if (!isEmpty(e.data)) {
    //   theme.mobile.notchHeight = Number(e.data);
    // }
  });
}

// notch 테스트
if (window.notchHeight) {
  theme.mobile.notchHeight = Number(window.notchHeight);
}

// vo 객체 활용
const initialState: UserVo = {
  userInfo: userInfo,
  listChips: [],
};

// 2. slice 생성 : createSlice
// reducer는 두 가지 인자를 받는데, 첫 번째는 이전 상태 정보가 들어오고 두 번째 인자는 아까 위에서 발생한 액션 객체
const userSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    setTokenLimit: (state, action: PayloadAction<number>) => {
      const tokenTime: any = jwtDecode(getCookie("ac_token"));
      const afterTime = tokenTime.exp * 1000;
      const currentTime = new Date().getTime();
      const resultTime = afterTime - currentTime;
      state.tokenTime = resultTime;
    },
    setListChips: (state, action: PayloadAction<Array<JSON | any>>) => {
      state.listChips = action.payload;
    },
    setGroupType: (state, action: PayloadAction<string>) => {
      state.group_type = action.payload;
    },
  },
});

// 3. export

// 3-1. export actions
export const { setTokenLimit, setListChips, setGroupType } = userSlice.actions;
// 3-2. export default slice.reducer
export default userSlice.reducer;
